import { TFeedFormValues } from '../helpers/types';
import { ICreateFeedDTO, IOption } from '@/models/feeds.model';

class CreateFeedDTO implements ICreateFeedDTO {
  locale?: Record<string, { name?: string }> | undefined;
  slug?: string;
  type?: string;
  category_ids: string[];
  region_ids: string[];
  store_ids?: string[];
  active: '1' | '0';
  min_price?: number | null;
  max_price?: number | null;
  in_stock_only?: boolean;
  exclude_from_general?: boolean;
  all_categories?: boolean;

  constructor(values: TFeedFormValues) {
    const {
      slug,
      category_ids: categoryIds,
      region_id: regionId,
      active,
      locale,
      type,
      store_ids: storeIds,
      min_price: minPrice,
      max_price: maxPrice,
      in_stock_only: inStockOnly,
      exclude_from_general: excludeFromGeneral,
      all_categories: allCategories,
    } = values;

    if (slug && slug !== '') {
      this.slug = slug;
    }

    this.type = type || 'google';

    this.all_categories = allCategories ?? false;

    // When "all categories" is enabled, the explicit selection is ignored by the backend.
    this.category_ids = this.all_categories
      ? []
      : (categoryIds as IOption[])?.[0]?.label
      ? categoryIds?.map((category) => (category as IOption).value) || []
      : (categoryIds as string[]);

    this.region_ids = (regionId as IOption[])?.[0]?.label
      ? regionId?.map((region) => (region as IOption).value) || []
      : (regionId as string[]);

    if (storeIds && storeIds.length > 0) {
      this.store_ids = (storeIds as IOption[])?.[0]?.label
        ? storeIds?.map((store) => (store as IOption).value) || []
        : (storeIds as string[]);
    }

    this.active = active ? '1' : '0';
    this.min_price = minPrice ?? null;
    this.max_price = maxPrice ?? null;
    this.in_stock_only = inStockOnly ?? false;
    this.exclude_from_general = excludeFromGeneral ?? true;

    this.locale = Object.fromEntries(
      Object.entries(locale || {}).map(([loc, { name }]) => [
        loc,
        {
          name: name,
        },
      ]),
    );
  }
}

export default CreateFeedDTO;
